import { isElement } from "./isElement";

export function getScrollableAncestors(el: HTMLElement | null) {
  const ancestors: HTMLElement[] = [];
  let node: Node | null = el;
  while (node && node !== document.documentElement && node !== document.body) {
    node = (node as HTMLElement).parentNode;
    if (!isElement(node)) continue;
    if (isScrollable(node)) ancestors.push(node);
  }
  return ancestors;
}

function isScrollable(el: HTMLElement) {
  const style = getComputedStyle(el);
  const overflowY = style.overflowY;
  const overflowX = style.overflowX;
  const canScrollY =
    (overflowY === "auto" || overflowY === "scroll") &&
    el.scrollHeight > el.clientHeight;
  const canScrollX =
    (overflowX === "auto" || overflowX === "scroll") &&
    el.scrollWidth > el.clientWidth;
  return canScrollY || canScrollX;
}
